import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./Provider/Auth/AuthProvider";
import { AlertProvider } from "./Provider/Alert/AlertContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <AlertProvider>
        <AuthProvider>
                <App />
        </AuthProvider>
    </AlertProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
